import React, { Suspense, lazy } from "react";
import {
  CardContainer,
  ChartLoadingContainer,
  LoadingSpinner,
  LoadingText,
} from "./index.styled";
import CardHeader from "./CardHeader";
import CardBody from "./CardBody";
import CardConversionRate from "./CardConversionRate";

// Lazy load the chart component to reduce initial bundle size
const CardChart = lazy(() => import("./CardChart"));

interface CardItem {
  title: string;
  value: number;
  type: string;
}

interface ChartDataPoint {
  time: string;
  users: number;
  views: number;
}

interface CardProps {
  card: {
    title: string;
    useBackground: boolean;
    showGraph: boolean;
    graphColor?: string;
    conversionRate?: number;
    chartData?: ChartDataPoint[];
    cards: CardItem[];
    isLoading?: boolean;
  };
  animationDelay?: number;
}

const Card: React.FC<CardProps> = ({ card, animationDelay = 0 }) => {
  return (
    <CardContainer
      $useBackground={card.useBackground}
      $animationDelay={animationDelay}
    >
      <CardHeader title={card.title} />
      {card.isLoading ? (
        <ChartLoadingContainer>
          <LoadingSpinner />
          <LoadingText>טוען נתונים...</LoadingText>
        </ChartLoadingContainer>
      ) : (
        <CardBody cards={card.cards} />
      )}
      {!card.isLoading && card.showGraph && card.chartData && (
        <Suspense
          fallback={
            <ChartLoadingContainer>
              <LoadingSpinner />
              <LoadingText>טוען גרף...</LoadingText>
            </ChartLoadingContainer>
          }
        >
          <CardChart
            data={card.chartData}
            graphColor={card.graphColor}
            cardTitle={card.title}
          />
        </Suspense>
      )}
      {!card.isLoading && card.conversionRate && (
        <CardConversionRate conversionRate={card.conversionRate} />
      )}
    </CardContainer>
  );
};

export default Card;
